import Axios from "axios";

class FuncionarioPreContratracaoDocumentosDataService {
  getAll() {
    return Axios.get("funcionarioPreContratracaoDocumentos");
  }

  getPage(params) {
    return Axios.get("funcionarioPreContratracaoDocumentos/page", { params });
  }

  create(params) {
    return Axios.post("funcionarioPreContratracaoDocumentos", params);
  }

  update(params) {
    return Axios.put(
      `funcionarioPreContratracaoDocumentos/${params.id}`,
      params
    );
  }

  find(id) {
    return Axios.get(`funcionarioPreContratracaoDocumentos/${id}`);
  }

  delete(id) {
    return Axios.delete(`funcionarioPreContratracaoDocumentos/${id}`);
  }
}

export default new FuncionarioPreContratracaoDocumentosDataService();
